import { render, staticRenderFns } from "./defaultMobile.vue?vue&type=template&id=7a48fd81"
import script from "./defaultMobile.vue?vue&type=script&lang=js"
export * from "./defaultMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports